export default api => ({
  load: lang => api.get(`/v1/${lang}/bi`),
})
